import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { MessageCircle } from "lucide-react";

const KIND = { budget_ready: "Orçamento pronto", car_ready: "Carro pronto", revision: "Lembrete de revisão", booking_reminder: "Véspera do agendamento" };

export function WaLogCard({ orderId, refreshKey }) {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get(`/orders/${orderId}/wa-logs`).then(({ data }) => setRows(data)).catch(() => setRows([])); }, [orderId, refreshKey]);
  if (!rows.length) return null;
  return (
    <div data-testid="order-wa-logs" className="rounded-xl border border-zinc-800 bg-zinc-900/40 p-3 space-y-1">
      <div className="flex items-center gap-1 text-[11px] font-mono-caps text-zinc-500"><MessageCircle className="h-3.5 w-3.5 text-emerald-400" /> WhatsApp automático</div>
      {rows.map((r, i) => (
        <div key={i} data-testid={`order-wa-log-${i}`} className="flex justify-between gap-2 text-xs">
          <span className="text-zinc-300">{new Date(r.at).toLocaleString("pt-BR")} · {KIND[r.kind] || r.kind}</span>
          <span className={r.status === "enviado" ? "text-green-400" : "text-red-400"} title={r.error || ""}>{r.status === "enviado" ? "Enviado" : `Falhou${r.error ? ` — ${r.error.slice(0, 60)}` : ""}`}</span>
        </div>
      ))}
    </div>
  );
}
